<div class="digital-clock">
  <span class="time">{{ currentTime }}</span>
</div>
